import * as yup from 'yup'

export class OutboundTripPhotosDto {
  driversLicensePhotoFileName?: string = undefined
  driversLicensePhotoFile?: File = undefined
}

export const outboundTripPhotosValidationSchema = yup.object({
  driversLicensePhotoFile: yup.mixed().required('Drivers License Photo is required.')
})
